import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { AuthService } from '@app/services/auth.service';
import { Component, ViewChild, OnInit } from '@angular/core';
import { Department } from '@models/company/department.model';
import { NotifyService } from '@app/services/notify.service';
import { ShowView } from '@common/views';
import { Platform } from '@app/classes/platform.class';
import { Paginator } from '@app/classes';
import { Employee } from '@models/employee/employee.model';

@Component({
    templateUrl: './department-show.template.html',
    styleUrls: ['./department-show.style.scss'],
})
export class DepartmentShowView extends ShowView implements OnInit {
    isLoading = true;
    editPermission: string[] = Department.permission.edit;
    department: Department;
    viewPeoplePermission: string[] = Platform.people.directory.permission.view;
    @ViewChild('confirmDeleteDialog', { static: true }) confirmDeleteDialog: DeprecatedConfirmationDialogComponent;
    paginator: Paginator;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private auth: AuthService
    ) {
        super();
        this.department = this.route.snapshot.data.models.get('department');

        this.paginator = new Paginator(
            Employee.param('company', this.auth.company.id)
                .with(['account', 'department', 'job'])
                .where('departmentId', this.department.id),
            { shouldAutoLoadData: true }
        );

        this.paginator.onLoading((isLoading) => {
            this.isLoading = isLoading;
        });
    }

    ngOnInit(): void {
        this.isLoading = false;
    }

    onSave(): void {
        if (!this.department.isDirty()) {
            return;
        }

        this.isLoading = true;
        this.department
            .param('company', this.auth.company.id)
            .save()
            .then(() => {
                this.notify.success('Department saved');
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'Could not save department');
                this.isLoading = false;
            });
    }

    onCancel(): void {
        this.department.revert();
    }

    onDelete(): void {
        this.confirmDeleteDialog.show().then((confirm) => {
            if (confirm) {
                this.department
                    .delete()
                    .then(() => {
                        this.notify.success('Department has been deleted');
                        this.router.navigate(['../'], { relativeTo: this.route });
                    })
                    .catch((err) => {
                        this.notify.error(err.message || 'Department could not be deleted');
                    });
            }
        });
    }

    getEmployeeListingFilter(): any {
        return {
            departmentId: this.department.id,
        };
    }
}
